import Swiper from 'swiper';
import { SwiperSlide } from 'swiper/react';

import { Typography } from '@common/styles';

import { useShortClipUBL } from '../log/useShortClipUBL';
import { ShortClipModel } from '../utils/types';
import { ShortClip } from './ShortClip';
import { ShortClipCard } from './ShortClipCard';
import { ShortClipCardCarousel } from './ShortClipCardCarousel';

interface ShortClipViewProps {
  isSingleList: boolean;
  shortClipContentList: ShortClipModel[];
  handleActiveIndexChange: (swiper: Swiper) => void;
  isRevealed: boolean;
  activeIndex: number;
  productId: string;
  handleShortClipClick: (id: string) => void;
}

export function ShortClipView({
  isSingleList,
  shortClipContentList,
  handleActiveIndexChange,
  isRevealed,
  activeIndex,
  handleShortClipClick,
  productId,
}: ShortClipViewProps) {
  const { shortClipImpressionUBL, shortClipClickUBL } = useShortClipUBL();

  return (
    <ShortClip>
      <ShortClip.Header>
        <ShortClip.Title className={Typography.BODY_17_SEMIBOLD}>
          <ShortClip.ClipIcon />
          클립
        </ShortClip.Title>
        <ShortClip.Subtitle className={Typography.BODY_14_REGULAR}>
          동영상으로 디테일까지 생생하게
        </ShortClip.Subtitle>
      </ShortClip.Header>
      <ShortClip.Carousel>
        <ShortClipCardCarousel
          onActiveIndexChange={handleActiveIndexChange}
          items={shortClipContentList}
          renderItem={(item, index) => {
            const isActive = index === activeIndex;
            return (
              <SwiperSlide
                className={isSingleList ? 'single' : ''}
                role='group'
                aria-roledescription='slide'
                key={item.id}
              >
                <ShortClipCard
                  data={item}
                  isReadyToLoadVideo={isRevealed || isActive}
                  isActive={isActive}
                  onImpression={() => {
                    shortClipImpressionUBL(item.id, productId, index);
                  }}
                  onClick={() => {
                    shortClipClickUBL(item.id, productId, index);
                    handleShortClipClick(item.id);
                  }}
                />
              </SwiperSlide>
            );
          }}
        />
      </ShortClip.Carousel>
    </ShortClip>
  );
}
